export default "__VITE_ASSET__BrMwnMDk__"